export const ADD_TODO = "addTodo";
export const ADD_MULTIPLE_TODOS = "addMutipleTodos";
export const TOGGLE_TODO = "toggleTodo";
export const DELETE_TODO = "deleteTodo";

export const EMPTY_TODO_LIST = "emptyTodoList";
